module.exports = __webpack_public_path__ + "img/girl.2a79185b.jpg";